export default "__VITE_ASSET__Dowe5YT0__"